import { createApp, h } from 'vue'
import { createInertiaApp } from '@inertiajs/vue3'
import SvgVue from 'svg-vue3';
import DefaultLayout from '@/Shared/Layout'

createInertiaApp({
    resolve: name => {
        const page = require(`@/Pages/${name}`).default
        page.layout = page.layout || DefaultLayout
        return page;
    },
    setup({ el, App, props, plugin }) {
        createApp({ render: () => h(App, props) })
            .use(plugin)
            .use(SvgVue)
            .mixin({methods: { route }})
            .mount(el)
    },
})
